// src/redux/websocketSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isConnected: false,
  messages: [],
};

const websocketSlice = createSlice({
  name: 'websocket',
  initialState,
  reducers: {
    setWebSocketMessage: (state, action) => {
      state.messages = [...state.messages, action.payload];
    },
    setWebSocketConnectionStatus: (state, action) => {
      state.isConnected = action.payload;
    },
    clearMessages: (state) => {
      state.messages = [];
    },
  },
});

export const { setWebSocketMessage, setWebSocketConnectionStatus, clearMessages } = websocketSlice.actions;

export const selectWebSocketMessages = (state) => state.websocket.messages;
export const selectWebSocketConnectionStatus = (state) => state.websocket.isConnected;

export default websocketSlice.reducer;